<template>
  <div :id="component_id" class="flex items-center gap-1.5 pt-1" :class="isCurrentUserMessage?'justify-end':'justify-start'">
    <div class="justify-start text-text-subtle text-xs font-normal" :data-user="message.senderId">{{ getMessageUserName(message) }}</div>
    <!-- bg-text-placeholder, not bg-surface-3: surface-3 is a BACKGROUND token (gray-10 light,
         gray-90 dark), so it tracked the page behind the dot rather than the text beside it and came
         out nearly invisible in both themes. A foreground token inverts correctly. Placeholder
         rather than text-subtle — one step lighter than the name and time it sits between, so the
         dot reads as punctuation rather than as a third word in the line. ReyConversationList's row
         separator is the same dot and was changed with it. -->
    <div class="fusion-message-timestamp-dot w-[2.87px] h-[2.87px] bg-text-placeholder rounded-full"></div>
    <div class="justify-start text-text-subtle text-xs font-normal">{{ formatMessageDate(message.sentAt) }}</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
      required: true
    },
    usersByGuid: {
      type: Object,
      required: false,
      default() {
        return {};
      }
    },
    isCurrentUserMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    tacChatData: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      Xmarkdown: null,
    }
  },
  computed: {
    component_key() {
      return this.$attrs.key?this.$attrs.key:('message_item_'+Date.now());
    },
    component_id() {
      return this.component_key+'_container';
    },
    tac_chat_agent_name() {
      if(this.tacChatData && this.tacChatData.agentFirstName && this.tacChatData.agentLastName)
        return `${this.tacChatData.agentFirstName} ${this.tacChatData.agentLastName}`;
      
      return null;
    },
  },
  methods: {
    getMessageUserName(message) {
      if(this.isCurrentUserMessage)
        return this.$t('messaging.you');
      
      let senderId = message.senderId;
      if (senderId === 'system_TACCHAT')
        return this.tac_chat_agent_name || this.$t('messaging.tacAgent');
      
      let userName = this.$FUSresolveGhostUser(senderId).friendlyName;
      if(this.usersByGuid && this.usersByGuid[senderId]) {
        const user = this.usersByGuid[senderId];
        userName = user || userName;
      }
      
      return userName;
    },
    formatMessageDate(dateStr) {
      const date = typeof dateStr === 'number'?new Date(dateStr*1000):new Date(dateStr);
      let fieldData = this.$FUSdateFormat('M/D/YYYY', date);
      if(this.dateIsToday(date))
        fieldData = '';
      if(this.dateIsYesterday(date))
        fieldData = this.$t('messaging.yesterday');
      
      fieldData += this.$FUSdateFormat(' h:mm A', date);
      
      return fieldData;
    },
    dateIsToday(d) {
      const today = new Date();
      return d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear();
    },
    dateIsYesterday(d) {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      return d.getDate() === yesterday.getDate() &&
        d.getMonth() === yesterday.getMonth() &&
        d.getFullYear() === yesterday.getFullYear();
    },
  },
}
</script>
